import { useEffect, useState } from 'react';

import { EVENT_NAME, type OpalEvent } from '@frontend/constants';

/**
 * Hook to track unread threads indicator state from chat-frontend.
 * Listens for custom events dispatched by chat-frontend.
 */
export function useUnreadThread() {
  const [hasUnreadThreads, setHasUnreadThreads] = useState(false);

  useEffect(() => {
    const handleUnreadChanged = (
      event: OpalEvent<typeof EVENT_NAME.OPAL_UNREAD_THREADS_CHANGED>
    ) => {
      setHasUnreadThreads(event.detail.hasUnreadThreads);
    };

    document.addEventListener(EVENT_NAME.OPAL_UNREAD_THREADS_CHANGED, handleUnreadChanged);

    return () => {
      document.removeEventListener(EVENT_NAME.OPAL_UNREAD_THREADS_CHANGED, handleUnreadChanged);
    };
  }, []);

  return { hasUnreadThreads };
}
